<template>
  <div class='h-dialogContainer'>
    <form :id="formId">
      <div class='h-subscriber-inputLit'>{{$t('MCS.groupNum')}}:</div>
      <ejs-textbox :value='numVal' v-model='numVal' name="groupNum" @keydown.native.enter='keydown' maxLength="40"></ejs-textbox>
      <!--<input :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model='numVal' name='groupNum'/>-->
    </form>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
export default {
  name: 'SearchDialog',
  props: [
    'userNumValue',
    'reFreshGrid'
  ],
  data() {
    return {
      validateObj: undefined,
      formId: 'searcgFormId',
      formValidateObj: '',
      numVal: this.userNumValue === undefined ? '' : this.userNumValue,
    };
  },
  methods: {
    keydown(){
      event.stopPropagation();//禁用回车事件
      event.preventDefault();
    },
    checkValid() {
      const checkStatus = this.validateObj.validate();
      return checkStatus;
    },
    bindValidate() {
      const validationOption = {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          groupNum: {
            regex: ["^[^\u4e00-\u9fa5]+$", this.$t('MCS.notAllowedChinese')]
            // rangeLength: [[1, 15], this.$t('SubscriberIms.maxlen15')],
            // maxLength: [63, this.$t('MCS.charAt63')]
          }
        },
      };
      this.validateObj = new FormValidator(`#${this.formId}`, validationOption);
    },
    search() {
      this.reFreshGrid(this.numVal.trim());
    },
    setData(num) {
      this.numVal = num;
    }
  },
};
</script>

<style scoped>

</style>
